import Doz from 'doz'
import hotLocationReload from 'doz-hot-location-reload'
import metaTag from 'doz-metatag'
import isSSR from 'doz-ssr/plugin'
import CONFIG from './config'
import DozRouter from 'doz-router'
import theme from './theme'
import axios from 'axios'
import './app.css'
import PageHome from './cmp/pages/home'

// This causes the page to reload in the browser
// when there are changes during the development phase
hotLocationReload(module);

// Plugin used during Server Side Rendering
Doz.use(isSSR);

// Plugin that changes the meta tags
Doz.use(metaTag, {
    title: window.PLAYER_CONFIG.title,
});

// Add configuration to all components,
// so it's possible call in this way this.CONFIG.FOO
Doz.mixin({
    CONFIG,
    PLAYER_CONFIG: window.PLAYER_CONFIG,
    THEME: theme(window.PLAYER_CONFIG),
    axios,
    CORS_PROXY: 'https://cors.xdevel.com/?url=',
    //CORS_PROXY: 'https://icors.now.sh/?',
    convertUTCDateToLocalDate(date) {
        let newDate = new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);
        let offset = date.getTimezoneOffset() / 60;
        let hours = date.getHours();
        newDate.setHours(hours - offset);
        return newDate;
    },
    scrollParentToChild(parent, child) {
        // Where is the parent on page
        let parentRect = parent.getBoundingClientRect();
        // What can you see?
        let parentViewableArea = {
            height: parent.clientHeight,
            width: parent.clientWidth
        };

        // Where is the child
        let childRect = child.getBoundingClientRect();
        // Is the child viewable?
        let isViewable = (childRect.top >= parentRect.top) && (childRect.top <= parentRect.top + parentViewableArea.height);

        // if you can't see the child try to scroll parent
        if (!isViewable) {
            // scroll by offset relative to parent
            parent.scrollTop = (childRect.top + parent.scrollTop) - parentRect.top
        }

    }
});

new Doz({

    root: '#app',

    //language=html
    template(h) {
        return h`
            <style> 
                /*header {
                    text-align: center;
                    background-color: ${this.PLAYER_CONFIG.headerBackgroundColor || this.THEME.primaryColor};
                    color: ${this.PLAYER_CONFIG.headerTextColor || this.THEME.onPrimaryColor};
                    height: 48px;
                }*/
                    
                :global html, :global body {
                    background: linear-gradient(360deg, ${this.THEME.primaryColor}, ${this.THEME.secondaryColor}) fixed;
                }

                .container {
                    padding: 48px 32px 32px;
                    /*border-bottom: 2px solid ${this.THEME.primaryColorDark};*/
                }
                
                .container h3 {
                    text-align: center;
                    text-transform: uppercase;
                }

                footer {
                    background-color: ${this.PLAYER_CONFIG.footerBackgroundColor || this.THEME.secondaryColor};
                    color: ${this.PLAYER_CONFIG.footerTextColor || this.THEME.onSecondaryColor};
                    padding: 32px;
                    text-align: center;
                }
            </style>
            <header></header>
            <main>
                <${DozRouter} mode="history">
                    <${PageHome} route="/:playerId"/>
                </${DozRouter}>
            </main>
        `
    },

    onCreate() {
        // Every time a component is mounted on the DOM,
        // I update the list of links mapped with the "data-router-link" attribute
        this.app.on('componentMountAsync', () => {
            if (this.router) {
                this.router.bindLink();
            }
        });
    },

    onMountAsync() {
        //console.log(this.PLAYER_CONFIG)
        if (window.SSR)
            window.SSR.ready();
        else {
            setTimeout(() => {
                document.getElementById('app').style.display = 'block'
            },500)

        }
    }

});
